import { render } from "./MessageBanner.vue?vue&type=template&id=5536f032&scoped=true"
import script from "./MessageBanner.vue?vue&type=script&lang=js"
export * from "./MessageBanner.vue?vue&type=script&lang=js"

import "./MessageBanner.vue?vue&type=style&index=0&id=5536f032&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5536f032"]])

export default __exports__